"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.productAPISearch.name': 'Product Search & Categories',
    'tools.productAPISearch.description': 'Search for products and retrieve product categories using SmartShop API integration',
};
